import React, { useEffect, useState } from 'react'
import './index.css'
import { IProps } from './interfaces'
import ActiveStep from './components/ActiveStep'


const Stepper = ({ steps, onChange, current = 0, type, controlled = false, fullText = false, numbers = true }: IProps) => {
    const [currentStep, setCurrentStep] = useState(current)

    useEffect(() => {
        setCurrentStep(current)
    }, [current])
    return (
        <section className={`container-steps ${type}`}>
            {steps.map((step, index) => {
                return currentStep == index ? <ActiveStep
                    controlled={controlled}
                    position={index}
                    onChange={(e) => {
                        setCurrentStep(e)
                        if (onChange) {
                            onChange(e)
                        }
                    }}
                    label={step.label}
                    key={step.key}
                    numbers={numbers}
                /> : <div
                    key={step.key}
                    onClick={() => {
                        if (controlled) return
                        setCurrentStep(index)
                        if (onChange) {
                            onChange(index)
                        }
                    }}
                    className='step-inactive'
                    style={fullText ? { width: '250px' } : {}}
                >{numbers ? index + 1 : ''} {fullText ? step.label : ''}
                </div>
            })}
        </section>
    )
}

export default Stepper
